import languages from "./languages";

const lang = {
  header: {
    home: "Home",
  },
  menu: {
    connect: "Connect",
    nometamask: "No Metamask",
  },
  message: {
    touchToUpdate: "Click images to regenerate.",
    processing: "Processing...",
    resources: "Resources",
  },
  mint: {
    switchNetwork: "Please switch the network.",
    switchNetworkButton: "Switch Network.",
    connectMetamask: "Please connect with Metamask.",
    mint: "Mint",
  },
  languages,
};

export default lang;
